import { createContext } from 'react';

/** The signed-in user, as little of them as the app actually needs. */
export type Me = {
    id: string;
    email: string;
};

export interface MeContextData {
    me: Me;
}

export const MeContext = createContext<MeContextData | undefined>(undefined);
